import { render, staticRenderFns } from "./MessageError.vue?vue&type=template&id=00efaf3e&scoped=true"
import script from "./MessageError.vue?vue&type=script&lang=js"
export * from "./MessageError.vue?vue&type=script&lang=js"
import style0 from "./MessageError.vue?vue&type=style&index=0&id=00efaf3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00efaf3e",
  null
  
)

export default component.exports